/** @format */

const chapter1 = (i18n) => ({
  title: i18n.t("overview:step_one"),
  icons: {
    default: require("static/header/mail.svg"),
    done: require("static/header/mail-done.svg"),
    check: require("static/header/check.svg"),
  },
});

const chapter2 = (i18n) => ({
  title: i18n.t("overview:step_two"),
  icons: {
    default: require("static/header/logins.svg"),
    done: require("static/header/logins-done.svg"),
    check: require("static/header/check.svg"),
  },
});

const chapter3 = (i18n) => ({
  title: i18n.t("overview:step_three"),
  icons: {
    default: require("static/header/details.svg"),
    done: require("static/header/details-done.svg"),
    check: require("static/header/check.svg"),
  },
});

const chapters = {
  first: (i18n) => () => chapter1(i18n),
  second: (i18n) => () => chapter2(i18n),
  third: (i18n) => () => chapter3(i18n),
};

const screens = {
  GDPR: (i18n) => () => ({
    title: i18n.t("overview:consent_header_title"),
  }),
};

module.exports = { chapters, screens };



// WEBPACK FOOTER //
// ./src/partners/config/header.js